import { Directive, ElementRef, HostListener, OnChanges, Renderer2, Self, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputFill]'
})
export class InputFillDirective {

  constructor(@Self() private ngControl: NgControl, private element: ElementRef,
private renderer: Renderer2) {
  }
  ngOnInit(): void {
    this.fill();
    this.ngControl.valueChanges.subscribe(v => this.fill());
  }

  @HostListener('change', ['$event']) onChange(evento: Event): boolean {
    this.fill();
    return false;
  }

  fill(): void {
    const elemento = this.element.nativeElement;
    if (elemento.value && elemento.value !== null && elemento.value !== '') {
      this.renderer.addClass( elemento, 'input-fill');
    } else {
      this.renderer.removeClass( elemento, 'input-fill');
    }
    
  }
}
